module.exports = __webpack_public_path__ + "img/1431366504.7914ae14.jpg";